(function FranchiseListReview($, Adzuki)
{
	'use strict';

	var form = {
		name: 'FranchiseListReviewSearch',
	};

	Adzuki.onload('FranchiseLists/review/', init, false);

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	function init()
	{
		$('#franchiselistreviewsearch-search_by').on('change', toggleSearchType);
		toggleSearchType();

		// click on thumbnail
		$('.list-thumbnail').on('click', function openThumbnail(event)
		{
			var thumbnail_path = $(this).data('img-path');

			event.preventDefault();

			if (thumbnail_path) {
				$('.modal-title').text('Franchise List Thumbnail');
				$('.modal-body').html('<img class="center-block" src="' + thumbnail_path + '">');
			}
		});
	}

	function toggleSearchType()
	{
		var search_by = $('#franchiselistreviewsearch-search_by').val();

		$('#franchise-list-client-search').hide();
		$('#franchise-list-segments').hide();
		$('#franchise-list-sources').hide();
		$('#franchise-list-cohorts-codes').hide();

		if (search_by === 'clients') {
			$('#franchise-list-client-search').show();
		} else if (search_by === 'segments') {
			$('#franchise-list-segments').show();
		} else if (search_by === 'sources' ) {
			$('#franchise-list-sources').show();
		} else {
			$('#franchise-list-cohorts-codes').show();
		}
	}

}(jQuery, window.Adzuki || {}));
